// extracted by mini-css-extract-plugin
export var actions = "_3h-0";
export var actionsContainer = "_3h-4";
export var border = "_3h-1";
export var childFullHeight = "_3h-b";
export var collapse = "_3h-2";
export var content = "_3h-6";
export var contentChild = "_3h-a";
export var fullscreen = "_3h-8";
export var hidePadding = "_3h-7";
export var noScrollX = "_3h-c";
export var noScrollY = "_3h-d";
export var optOutTopPadding = "_3h-9";
export var pagePadding = "_3h-5";
export var profile = "_3h-e";
export var profileContainer = "_3h-f";
export var profileImage = "_3h-g";
export var profileMain = "_3h-h";
export var profileSubtitle = "_3h-j";
export var profileTitle = "_3h-i";
export var tabsWrapper = "_3h-3";
export var title = "_3h-k";